/**
 * Same interface like the lib "cookies-js", but the set function returns a
 * boolean, indicating whether the set operation was successful.
 * If it was not successful, it's probably because the cookie is too long.
 * Not that the measurement of "too long" is browser dependent and usually
 * includes other cookies of the same domain.
 */
import Cookies from "js-cookie";
// Cache to avoid reparsing cookies all the time - we read cookies a lot
let lastCookie: string | null = null;
let cookies: Record<string, string> | null = null;
export function set(
	cookieName: string,
	wantedValue: string | null | undefined,
	cookieOptions: Record<string, any>,
): boolean {
	Cookies.set(cookieName, wantedValue, cookieOptions);
	const actualValue = get(cookieName);
	return actualValue === wantedValue;
}
export function get(cookieName: string): string | null | undefined {
	if (!cookies || lastCookie !== document.cookie) {
		cookies = Cookies.get();
		lastCookie = document.cookie;
	}

	return cookies![cookieName] === "undefined" ? undefined : cookies![cookieName];
}
export function expire(cookieName: string): boolean {
	Cookies.remove(cookieName);
	return get(cookieName) === undefined;
}
export function makeCookieOptions(expiresDate?: Date | null | undefined): {
	path: string;
	expires: Date;
	secure: boolean;
} {
	let date = expiresDate;

	if (!date) {
		date = new Date();
		date.setHours(date.getHours() + 100);
	}

	const options = {
		path: "/",
		expires: date,
		secure: false,
		sameSite: "strict",
	};

	if (/^https.*/.test(window.location.protocol)) {
		options.secure = true;
	}

	return options;
}
